export { invoicesManifest, invoicesPermissions } from "./invoices-manifest";
